import { useTranslation } from 'react-i18next'

export const Loading = ({ message, fullScreen = false, size = 'medium', className = '' }) => {
    const { t } = useTranslation()

    const sizeClasses = {
        small: 'h-6 w-6',
        medium: 'h-8 w-8',
        large: 'h-12 w-12',
    }

    const defaultMessage = t('loading')

    return (
        <div
            className={`flex flex-col items-center justify-center gap-3 ${
                fullScreen ? 'fixed inset-0 bg-white bg-opacity-80 z-50' : ''
            } ${className}`}
        >
            <Spinner className={`animate-spin ${sizeClasses[size]}`} />
            <p className='text-center text-gray-600'>{message || defaultMessage}</p>
        </div>
    )
}

// Simple spinner component if you don't have one
export const Spinner = ({ className }) => (
    <div className={`border-4 border-t-primary border-transparent rounded-full ${className}`} />
)

export const LoadingOverlay = ({ message, showSpinner = true }) => {
    const { t } = useTranslation()

    return (
        <div className='fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30 backdrop-blur-sm'>
            <div className='flex flex-col items-center max-w-md p-6 mx-4 bg-white rounded-lg shadow-xl'>
                {showSpinner && (
                    <div class='lds-ring'>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                )}
                <p className='text-lg font-medium text-gray-800'>{message || t('loading')}</p>
            </div>
        </div>
    )
}

export const ErrorOverlay = ({ message, onClose }) => {
    const { t } = useTranslation()
    return (
        <div className='fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm'>
            <div className='relative w-full max-w-md mx-4 bg-white border border-red-200 shadow-2xl rounded-xl'>
                {/* Close Button */}
                {onClose && (
                    <button
                        onClick={onClose}
                        className='absolute p-1 rounded-full top-3 right-3 hover:bg-gray-100'
                        aria-label='Close'
                    >
                        <svg
                            className='w-5 h-5 text-gray-500'
                            fill='none'
                            stroke='currentColor'
                            viewBox='0 0 24 24'
                        >
                            <path
                                strokeLinecap='round'
                                strokeLinejoin='round'
                                strokeWidth={2}
                                d='M6 18L18 6M6 6l12 12'
                            />
                        </svg>
                    </button>
                )}

                {/* Content */}
                <div className='p-6'>
                    {/* Icon */}
                    <div className='flex justify-center mb-4'>
                        <div className='p-3 bg-red-100 rounded-full'>
                            <svg
                                className='w-12 h-12 text-red-600'
                                fill='none'
                                stroke='currentColor'
                                viewBox='0 0 24 24'
                            >
                                <path
                                    strokeLinecap='round'
                                    strokeLinejoin='round'
                                    strokeWidth={2}
                                    d='M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z'
                                />
                            </svg>
                        </div>
                    </div>

                    {/* Message */}
                    <div className='text-center'>
                        <h3 className='mb-2 text-xl font-semibold text-red-900'>
                            {t('error.default')}
                        </h3>
                        <p className='leading-relaxed text-red-700'>{message}</p>
                    </div>
                </div>
            </div>
        </div>
    )
}
